var stickyOffset = 0;
function getURLVar(key) {
  var value = [];

  var query = String(document.location).split('?');

  if (query[1]) {
    var part = query[1].split('&');

    for (i = 0; i < part.length; i++) {
      var data = part[i].split('=');

      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }

    if (value[key]) {
      return value[key];
    } else {
      return '';
    }
  }
}
/*
function removeParam(sourceURL, key, value) {
  var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split("=")[0];
      val = params_arr[i].split("=")[1];
      if (param === key && val === value) {
        params_arr.splice(i, 1);
      }
    }
    if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}
*/
function replaceUrlParam(url, paramName, paramValue) {
  var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
      newUrl = url.replace(pattern,'$1' + paramValue + '$2');
  if ( newUrl == url ) {
    newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
  }
  return newUrl;
}
function filterCollParam(url) {
  $.ajax({
    type: 'GET',
    url: url,
    data: {},
    beforeSend: function( xhr ) {
      $("#wraper_ajax").show();
    },
    complete: function (data) {  
      //$('#body').load('/ #body');
      //console.log($("#body", data.responseText).html());
      //$('#body').html($("#body", data.responseText).html());

      $('#custom-products').html($("#custom-products", data.responseText).html());
      $('#fp_filter_bar').html($("#fp_filter_bar", data.responseText).html());
      $('#active-filters').html($("#active-filters", data.responseText).html());
      $('#column-left').html($("#column-left", data.responseText).html());
      $('#collection-amount').html($("#collection-amount", data.responseText).html());
      if(localStorage.getItem('type') == null) {
        var type = $('#category-view-type').val();
        var cols = $('#category-grid-cols').val();

        if(type == "list") {
          category_view.initView(type, cols, 'btn-list');
          category_view.customPriceBoxList();
        }

        if(type == 'grid') {
          category_view.initView(type, cols, 'btn-grid-' + cols);
          category_view.customPriceBoxGrid();
        }
      } else {
        var type = localStorage.getItem('type');
        //var cols = localStorage.getItem('cols'); Not taking from cache because one column count allowed at a time
        var cols = $('#category-grid-cols').val();
        var element = localStorage.getItem('element');

        category_view.initView(type, cols, element);
      }
      $('#pagination').html($("#pagination", data.responseText).html());
      //console.log(url);
      history.pushState({
        page: url
      }, url, url);      
      $("#wraper_ajax").hide();
      SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      $("[data-bg-color]").each(function () {
        $(this).css("background", $(this).attr("data-bg-color"))
      });
      
      setTimeout(function () {
        Wishlist.init();
      }, 300);
      

      if($("#slider-range").length){
        var min_val = $( "#amount" ).data('minn');
        var max_val = $( "#amount" ).data('maxx');
        var max_range = $( "#amount" ).attr('max');
        var slider_currency = $( "#amount" ).data('currency');
        $( "#slider-range" ).slider({
          range: true,
          min: 0,
          max: max_range,
          values: [ min_val, max_val ],
          slide: function( event, ui ) {
            $( "#amount" ).val( slider_currency + ui.values[ 0 ] + " - " + slider_currency + ui.values[ 1 ] );       
          }
        });
        $( ".sb_widget.sb_pricing_range" ).on( "slidechange", "#slider-range", function( event, ui ) {
          $( "#amount" ).val( slider_currency + ui.values[ 0 ] + " - " + slider_currency + ui.values[ 1 ] ); 
        } );
        $( "#amount" ).val( slider_currency + $( "#slider-range" ).slider( "values", 0 ) +
                           " - " + slider_currency + $( "#slider-range" ).slider( "values", 1 ) );
      }
      /*
      $( "#amount" ).val( slider_currency + $( "#slider-range" ).slider( "values", 0 ) +
                         " - " + slider_currency + $( "#slider-range" ).slider( "values", 1 ) );
                         */
    }
  });
}

function isEmpty( el ){
  return !$.trim(el.html())
}
$(document).ajaxStop(function() {
  function isEmpty( el ){
    return !$.trim(el.html())
  }
  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');      
  }	
});

// resize code for equal size grids and content start
var img_ratio = 1.0/1.0;


$(document).ready(function() {

  /* $('.shopify-currency-form select').on('change', function() {
    $(this)
    .parents('form')
    .submit();
  });*/

  //mass.equalDivs();
  //mass.resizeInsta();
  


  // sidebar mobile toggle code start 
  /*  if ($(window).width() <=991 ) {

    $('#sidebar-toggle .oc-menu-bar').click(function (e) {
      e.stopPropagation();
      var effect = $(this).closest('#sidebar-toggle.oc-menu').find('.menu-effect').val();
      $('#column-left').addClass('sidebar-toggle');
      $('.sidebar-overlay').toggle();
      if(effect == "none") {
        $('#column-left').toggle();
      }

      if(effect == "fade") {
        $('#column-left').fadeToggle();
      }

      if(effect == "slide") {
        $('#column-left').slideToggle();
      }

    });

    $('#column-left').click(function(e){
      e.stopPropagation();
    });

    $(document.body).click(function(e){
      var effect = $('#sidebar-toggle.oc-menu').find('.menu-effect').val();
      $('.sidebar-overlay').hide();
      if(effect == "none") {
        $('#column-left').hide();
      }
      if(effect == "fade") {
        $('#column-left').fadeOut();
      }
      if(effect == "slide") {
        $('#column-left').slideUp();
      }
    });
  }*/
  // sidebar mobile toggle code end

  // Adding active class for mobtabs on mobile layout
  $('.mobtab a').click(function(e){
    $('.mobtab a').removeClass('active');
    $(this).addClass('active');
  });

  // product video 
  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  // color swatch js snippet
  $('.swatch :radio').change(function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });

  // product page add to cart
  $('#button-cart').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy input, #form_buy select'),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart').button('loading');
      },
      complete: function() {
        $('#button-cart').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        $.getJSON('/cart.js', function(cart) {
          load(cart);
        });

        
        toastr.success("Congratulation! Your item has been added.");
                       $('html, body').animate({ scrollTop: 0 }, 'slow');
        

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning("Item variant already added to the cart.");
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  $('#button-cart-sticky').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy input, #form_buy_sticky select'),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart-sticky').button('loading');
      },
      complete: function() {
        $('#button-cart-sticky').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        $.getJSON('/cart.js', function(cart) {
          load(cart);
        });

        
        toastr.success("Congratulation! Your item has been added.");
                       $('html, body').animate({ scrollTop: 0 }, 'slow');
        
      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning("Item variant already added to the cart.");
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  $('#button-cart-buy').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy input, #form_buy select'),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart-buy').button('loading');
      },
      complete: function() {
        $('#button-cart-buy').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        $.getJSON('/cart.js', function(cart) {
          window.top.location.href="/checkout";
        });

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning("Item variant already added to the cart.");
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  //stickyMenu();
  /*
  var headerSpaceH = $('header').outerHeight(true);
  $('header').before('<div class="headerSpace unvisible" style="height:'+headerSpaceH+'px;"></div>');	

  // Scroll
  var currentP = 0;
  var stickyOffset1 = 0;

  stickyOffset = $('header').offset().top;
  stickyOffset += $('header').outerHeight();
  if(isEmpty($('header.hd2'))) { 
    stickyOffset += 30;
  }

  if (!isEmpty($('#product-product'))) {
    stickyOffset1 = $('#form_buy').offset().top;
    stickyOffset1 += $('#form_buy').outerHeight();
  }

  $(window).scroll(function(){
    var headerH = $('header').height();
    var scrollP = $(window).scrollTop();
    var winInnW = window.innerWidth;

    if(scrollP != currentP){
      //Sticky header
      if( winInnW > 991 ){
        if(scrollP >= stickyOffset){
          $('.fix').addClass('fix-header');

          $('.headerSpace').removeClass('unvisible');
          $('.headerSpace').addClass('show');

        } else {
          $('.fix').removeClass('fix-header');

          $('.headerSpace').addClass('unvisible');
          $('.headerSpace').removeClass('show');

        }
      }
      if (!isEmpty($('#product-product'))) {

        if(scrollP >= stickyOffset1){
          $('.form_buy_sticky').addClass('fix-header2');
          $('.form_buy_sticky').addClass('fix-header1');
          $('html').css('padding-bottom','64px');
        } else {
          $('.form_buy_sticky').removeClass('fix-header1');
          $('.form_buy_sticky').removeClass('fix-header2');
          $('html').css('padding-bottom','0px');
        } 
      }
      currentP = $(window).scrollTop();
    }
  });

  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');      
  }
  if (!isEmpty($('#product2'))) {
    $('#product2 .option-container').addClass('has-option');      
  }

  // move breadcrumbs
  /*$("header").after('<div class="breadcrumbs"><div class="container"></div></div>');	
  var breadcrumb = $('ul.breadcrumb');
  var breadcrumbs_container = $('.breadcrumbs .container');
  var breadcrumbs = $('.breadcrumbs');
  if(isEmpty($('body.common-home'))) { 
    if(!isEmpty($('#content > h1'))) { 
      var page_title = $('#content > h1');
    } else if(!isEmpty($('#content h1:first-of-type'))) { 
      var page_title = $('#content h1:first-of-type');
    } else if(!isEmpty($('#content h2:first-of-type'))) { 
      var page_title = $('#content h2:first-of-type');
    } else {
      var page_title = $('#content h3:first-of-type');
    }
    page_title.prependTo(breadcrumbs);
  }
  breadcrumb.appendTo(breadcrumbs_container);

  if ($(".hd3").length) {
    breadcrumbs.addClass('hd3');
  }*/
  // Highlight any found errors
  /* $('.text-danger').each(function() {
    var element = $(this).parent().parent();

    if (element.hasClass('form-group')) {
      element.addClass('has-error');
    }
  });*/

  //stickyCartBar();
  // Scroll
  var currentP = 0;
  var stickyOffset1 = 0;

  if (!isEmpty($('.product-product'))) {
    stickyOffset1 = $('#form_buy').offset().top;
    stickyOffset1 += $('#form_buy').outerHeight();
  }

  if (!isEmpty($('.sticky_footer'))) {
    $(window).scroll(function(){
      var headerH = $('header').height();
      var scrollP = $(window).scrollTop();
      var winInnW = window.innerWidth;

      if(scrollP != currentP){
        //Sticky
        if (!isEmpty($('.product-product'))) {

          if(scrollP >= stickyOffset1){
            $('.sticky_footer').addClass("stuck")
            //$('.form_buy_sticky').addClass('fix-header2');
            //$('.form_buy_sticky').addClass('fix-header1');
            $('html').css('padding-bottom','80px');
          } else {
            $('.sticky_footer').removeClass("stuck")
            //$('.form_buy_sticky').removeClass('fix-header1');
            //$('.form_buy_sticky').removeClass('fix-header2');
            $('html').css('padding-bottom','0px');
          } 
        }
        currentP = $(window).scrollTop();
      }
    });
  }

  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');      
  }
  if (!isEmpty($('#product2'))) {
    $('#product2 .option-container').addClass('has-option');      
  }

  /* Search */
  //$('#btn-search-category').click(function () {
  /*
  $('#search input[name=\'q\']').parent().find('button').on('click', function() {
    var url = '/search';
    var type = $('#search input[name=\'type\']').val();
    if(type == 'blog') {
      var value = $('#search.blog input[name=\'q\']').val();
    } else {
      var value = $('#search input[name=\'q\']').val();
      type = 'product';
    }

    if(value == "Search all products..." || value ==""){
      jQuery('#search input[name=\'q\']').focus();
      return false;
    }else {
      url += '?type=' + type + '&q=' + encodeURIComponent(value);
    }

    location = url;
  });

  $('#search input[name=\'q\']').on('keydown', function(e) {
    if (e.keyCode == 13) {
      if($('#search input[name=\'type\']').val() == 'blog') {
        $('#search.blog input[name=\'q\']').parent().find('button').trigger('click');        
      } else {
        $('header #search input[name=\'q\']').parent().find('button').trigger('click');
      }
    }
  });
*/
  // Menu
  $('#menu .dropdown-menu').each(function() {
    var menu = $('#menu').offset();
    var dropdown = $(this).parent().offset();

    var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());

    if (i > 0) {
      $(this).css('margin-left', '-' + (i + 10) + 'px');
    }
  });
  /*
  // Product List
  $('#list-view').click(function() {
    $('#content .product-grid > .clearfix').remove();

    $('#content .row > .product-grid').attr('class', 'product-layout product-list col-6 product-item');
    $('#grid-view').removeClass('active');
    $('#list-view').addClass('active');

    $(".product-item .item").each(function() {
      var caption = $(this).find('.caption');
      $(this).find('.action-links').appendTo(caption);
    });

    localStorage.setItem('display', 'list');
    localStorage.setItem('type', 'none');
  });

  // Product Grid
  $('#grid-view').click(function() {
    var cols = $('#column-right, #column-left').length;

    if (cols == 2) {
      $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-6 col-md-6 col-sm-6 col-xs-6 product-item');
    } else if (cols == 1) {
      $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-4 col-md-4 col-sm-6 col-xs-6 product-item');
    } else {
      $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-3 col-md-3 col-sm-6 col-xs-6 product-item');
    }

    $('#list-view').removeClass('active');
    $('#grid-view').addClass('active');

    $(".product-item .item").each(function() {
      var images_container = $(this).find('.images-container');
      $(this).find('.action-links').appendTo(images_container);
    });

    localStorage.setItem('display', 'grid');
    localStorage.setItem('type', 'none');
  });

  if (localStorage.getItem('display') == 'list') {
    $('#list-view').trigger('click');
    $('#list-view').addClass('active');
  } else {
    $('#grid-view').trigger('click');
    $('#grid-view').addClass('active');
  }

  // grid-style

  $('.grid-style .item').mouseover(function() {
    $(this).closest('.grid-style').addClass('active');
  });
  $('.grid-style .item').mouseout(function() {
    $(this).closest('.grid-style').removeClass('active');
  });
*/
  // Checkout
  $(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
    if (e.keyCode == 13) {
      $('#collapse-checkout-option #button-login').trigger('click');
    }
  });

  // tooltips on hover
  $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});

  // Makes tooltips work on ajax generated content
  $(document).ajaxStop(function() {
    $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
  });
});

// Cart add remove functions
var cart = {
  'add': function(product_id, quantity,redirect) {
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: 'id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
      dataType: 'json',
      beforeSend: function() {
        var btn = $(this);
        if(redirect) {
          $('.button-cart.button').button('loading');
        } else {
          $('.button-cart > .button').button('loading');
        }

      },
      complete: function() {
        if(redirect) {
          $('.button-cart.button').button('reset');
        } else {
          $('.button-cart > .button').button('reset');
        }
      },
      success: function(json) {
        $('.alert, .text-danger').remove();

        if (json['redirect']) {
          location = json['redirect'];
        }

        $.getJSON('/cart.js', function(cart) {
          if(redirect) {
            window.top.location.href="/checkout";
          }
          
          toastr.success("Congratulation! Your item has been added.");
                         load(cart);
          
        });
      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning("Item variant already added to the cart.");
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  },
  'remove': function(key) {
    $.ajax({
      url: '/cart/update.js',
      type: 'post',
      data: 'updates['+key+']=0',
      dataType: 'json',
      beforeSend: function() {
        //$('#cart > button').button('loading');
      },
      success: function(json) {
        //$('#cart > button').button('reset');
        if (getURLVar('route') == '/cart' || getURLVar('route') == '/checkout') {
          location = '/cart';
        } else {
          setTimeout(function () {
            load(json);
          }, 5);       
        }
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(xhr.responseText);
      }
    });
  }
}

function load(cart){
  $('#cart ul.cart_items_list > li').remove();
  $.each(cart.items, function (index, cartItem) {
    var line = index + 1;
    var cents = "";

    if (cartItem.price % 100 < 10) {
      cents = "0";
    }
    var price = parseInt(cartItem.price / 100) + "." + cents + cartItem.price % 100;

    var cartRemove = 'onclick="cart.remove(\''+cartItem.id+'\')"';
    var cartItem = "<li><div class='item_image'><a href='" + cartItem.url + "' title='" + cartItem.title + "'><img class='cart-image' src='" + cartItem.image + "' alt='" + cartItem.title + "' title='" + cartItem.title + "'></a></div><div class='item_content'><h4 class='item_title'>"+ cartItem.title +"</h4><span class='item_price'><span class='money'>" + Shopify.formatMoney(price, moneyFormat) + "</span> &times; " + cartItem.quantity + "</span></div><button type='button' "+cartRemove+" class='remove_btn'><i class='fa fa-trash-alt'></i></button></li>";
    //var cartItem = "<tr><td class='text-center'><a href='" + cartItem.url + "' title='" + cartItem.title + "'><img class='cart-image' src='" + cartItem.image + "' alt='" + cartItem.title + "' title='" + cartItem.title + "'></a></td><td class='text-left info-item'><a class='cart-name' href='" + cartItem.url + "'>" + cartItem.title + "</a><p class='cart-quantity'>" + cartItem.quantity + " &times;</p><p class='cart-price'><span class='money'>" + Shopify.formatMoney(price, moneyFormat) + "</span></p></td><td class='text-center cart-close'><button type='button' "+cartRemove+"' title='Remove' class='btn btn-danger btn-xs'><i class='ion-android-close'></i></button></td></tr>";
    $('#cart ul.cart_items_list').append(cartItem);
  });
  if (cart.item_count < 1) {
    $('#cart ul.cart_items_list').append('<li><p class="text-center cart-empty">Your shopping cart is empty!</p></li>');
                                         $('#cart ul.total_price').addClass('d-none');
    $('#cart ul.btns_group').addClass('d-none');
  } else {
    $('#cart ul.cart_items_list > li > p.cart-empty').remove();
    $('#cart ul.total_price').removeClass('d-none');
    $('#cart ul.btns_group').removeClass('d-none');
  }
  $('.btn_badge').html(cart.item_count);
  //$('#cart > button .total-price').html('<span class=money>'+Shopify.formatMoney(cart.total_price, moneyFormat)+'<i class="fas fa-chevron-down"></i></span>');
  $('#cart-subtotal').html('<span class=money>'+Shopify.formatMoney(cart.total_price, moneyFormat)+'</span>');
  
}